import { gql } from "@apollo/client";

import RunActionFieldsFragment from "components/Run/elements/ActionButtons/ActionFragment";

// Remember about syncing this query with the GetVersionRun query in
// src/views/module/Version/Run/index.tsx
export const GET_RUN = gql`
  query GetModuleRun($moduleId: ID!, $runId: ID!) {
    module(id: $moduleId) {
      id
      isDisabled
      run(id: $runId) {
        ...RunActionFieldsFragment
        branch
        canRetry
        promoteBlocker
        command
        createdAt
        priorityPreset
        commit {
          authorLogin
          authorName
          hash
          timestamp
          url
        }
        comments {
          __typename
          body
          createdAt
          username
        }
        delta {
          addCount
          changeCount
          deleteCount
          resources
          importCount
          forgetCount
          moveCount
        }
        expectFailure
        needsApproval
        driftDetection
        expired
        externalDependencies {
          id
          status
          completedAt
          createdAt
        }
        isMostRecent
        reviews {
          id
          author
          decision
          note
          timestamp
        }
        planPoliciesOutcomes {
          id
          deny
          warn
          createdAt
        }
        policyReceipts {
          id
          flags
          createdAt
          policyName
          policyType
          policySlug
          outcome
          sampled
          sampleExpired
        }
        runtimeConfig {
          projectRoot
          terraform {
            version
          }
        }
        title
        triggeredBy
        type
        next {
          id
        }
        previous {
          id
        }
      }
    }
  }
  ${RunActionFieldsFragment}
`;
